import { ITracking } from '../../types/tracking';

export const TRACKING_DEFAULT_PARAMS: ITracking = {
  user: {},
  page: {
    pageType: 'CardCompany',
    siteType: 'desktop',
  },
  products: [],
};
